import * as Yup from 'yup';

export const isNumeric = (value: string): boolean => {
    return /^\d*$/.test(value);
};

export const ApplicationIDValidationSchema = Yup.object().shape({
    idInput: Yup.string()
        .test('is-numeric', 'ID must be numeric.', (value) => {
            return value === undefined || isNumeric(value);
        })
        .required('ID is required.'),
});
